import { ReactElement, useCallback, useMemo } from 'react';
import { Stack, DialogContentText, Link, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '~hooks/useAppSelector';
import { useTypePartnerCompany } from '~hooks/useTypePartnerCompany';
import { selectAuth } from '~store/slices/auth/index';
import { isAdminUser } from '~utils/user';
import { PATHS } from '~constants/paths';

const DialogAssingBillingListEmptyState = (): ReactElement => {
  const navigate = useNavigate();
  const { user } = useAppSelector(selectAuth);
  const { isCarrier } = useTypePartnerCompany();

  const isAdmin = useMemo(() => isAdminUser(user), [user]);

  const handleRedirectToIntegrations = useCallback(
    () => navigate(PATHS.CONFIG.BILLING_LIST.BASE),
    [navigate],
  );

  return (
    <Stack spacing={2} flex={1} justifyContent="center" alignItems="center">
      <DialogContentText color="text.primary">
        No se encontraron lista de precios
      </DialogContentText>

      <Stack spacing={2} direction="row">
        {isAdmin && (
          <Button
            variant="contained"
            color="primary"
            onClick={handleRedirectToIntegrations}
          >
            Agregar lista de precios
          </Button>
        )}
      </Stack>

      <DialogContentText
        variant="caption"
        // @NEW-GIVER-DASHBOARD: Hide until the help URL is available for Givers
        visibility={isCarrier ? 'visible' : 'hidden'}
      >
        Para mayor información sobre asignación de lista de precios diríjase a
        este{' '}
        <Link
          href="https://routix.tawk.help/article/asignar-lista-de-precios"
          target="_blank"
          rel="noopener noreferrer"
          color="primary"
          underline="hover"
          fontWeight="bold"
        >
          artículo
        </Link>
      </DialogContentText>
    </Stack>
  );
};

export default DialogAssingBillingListEmptyState;
